<ng-container *transloco="let t">
  <ld-base-modal [title]="t('modalsInsuranceTransitionTitle')" (closeModal)="cancel.emit()">
    <div modal-content>
      @if (isLoading()) {
        <div class="flex flex-col items-center justify-center py-8">
          <mat-spinner diameter="40" class="mb-4"></mat-spinner>
          <p class="text-body text-ld-neutral-500">{{ t('commonLabelsLoading') }}</p>
        </div>
      } @else {
        <div class="space-y-6">
          <div class="flex justify-center">
            @if (vendor() === 'geico') {
              <img
                id="geico-vendor-logo"
                src="assets/images/vendor-geico.png"
                alt="GEICO"
                class="h-12 w-auto object-contain"
              />
            } @else {
              <mat-icon class="text-ld-primary text-5xl! w-12! h-12!">home</mat-icon>
            }
          </div>

          <div class="text-center">
            <h3 class="text-card-title text-ld-neutral mb-2">
              {{ getVendorDescription() }}
            </h3>
          </div>

          <div class="p-4 bg-ld-neutral-50 rounded-xl">
            <p class="text-body text-ld-neutral">
              {{ getAuthorizationText() }}
              Please refer to
              <a
                [href]="getPrivacyPolicyUrl()"
                target="_blank"
                rel="noopener noreferrer"
                class="text-ld-primary hover:underline"
              >
                {{ getPrivacyPolicyLabel() }}
              </a>
              .
            </p>
          </div>

          <!-- State License Verbiage -->
          @if (vendor() === 'geico' && verbiage()?.stateLicenseVerbiage) {
            <div class="p-4 bg-amber-50 border border-amber-200 rounded-xl">
              <div class="flex items-start gap-2">
                <mat-icon class="text-amber-600 shrink-0 mt-0.5 text-lg!">info_outline</mat-icon>
                <div>
                  <p class="font-dm text-xs text-amber-800 font-medium mb-1">State Disclosure</p>
                  <p class="font-dm text-xs text-amber-700" [innerHTML]="verbiage()?.stateLicenseVerbiage"></p>
                </div>
              </div>
            </div>
          }

          @if (errorMessage()) {
            <div class="p-3 bg-red-50 border border-red-200 rounded-lg">
              <p class="text-body text-red-700">{{ errorMessage() }}</p>
            </div>
          }
        </div>
      }
    </div>
    <div modal-footer>
      <button
        id="insurance-transition-cancel-btn"
        type="button"
        class="btn-outline-ld-purple"
        [disabled]="isProcessing()"
        (click)="onCancel()"
      >
        Cancel
      </button>
      <button
        id="insurance-transition-continue-btn"
        type="button"
        class="btn-primary-ld-purple"
        [disabled]="isLoading() || isProcessing()"
        (click)="onContinue()"
      >
        @if (isProcessing()) {
          <mat-spinner diameter="16" class="w-4! h-4! [&_circle]:stroke-white!"></mat-spinner>
        } @else {
          <mat-icon class="text-lg!">open_in_new</mat-icon>
        }
        {{ getContinueButtonText() }}
      </button>
    </div>
  </ld-base-modal>
</ng-container>
